import React from 'react'
import cx from 'classnames';
import {getGradeLabel} from "Components/Reports/util/labels";
import {assignmentTypes} from "Constants/constants";
import getActivityType from "Components/Reports/util/getActivityType"
import { scoreFormat } from '../../../util/numberFormatters/scoreFormat';
import { displayScore } from '../../../util/stringFormatters/displayScore';
import ProgressTableHeader from './ProgressTableHeader';
import orderBy from 'lodash.orderby';
import { locales } from '../../../../../constants/constants';
import { isEarlyReader } from '../../../../../services/EarlyReaderService';
import cloneDeep from 'lodash.clonedeep';
import DialogIndicator from '../../../../Global/DialogIndicator/DialogIndicator';


export default function ProgressTable(props) {

    const { report, embedded, selectedLocale, selectedMetric } = props

    if(embedded) return null

    // search for "ARM SPANISH SCORES" to find other places where ARM score is determined.
    const reportData = cloneDeep(report); // Create a deep copy of the report object

    // What do we do for early reader?
    // if (selectedLocale === locales.ES_MX && selectedMetric.value === 'ARM') {
    //   reportData.data.forEach((obj) => {
    //     if (isEarlyReader(obj)) {
    //       obj.score = null;
    //     }
    //   });
    // }
    

    const containerStyle = {}
    const isEmpty = !reportData.data[0]
    if (isEmpty) containerStyle.marginTop = 20;

    const progressTableStyles = cx({
        'trackingTableBody': true,
        'progress': true,
       });

    return (
        <div className={progressTableStyles} style={containerStyle}>
            <div className="trackingTableContainer">
                <table className="tracking-table-body">
                    <ProgressTableHeader scale={reportData.label} />
                    <tbody className="tracking-table-body-container">
                        {reportData && reportData.data && orderBy(reportData.data, ['date'], ['desc']).map(({ type, score, date, id, timeRead, storyTitle, storyGrade, storyTags, hasComprehensionDialog }) => {
                            let timeReadLabel;
                            if (timeRead == '') {
                                timeReadLabel = timeRead;
                            } else {
                                const timeMinutes = new Date(timeRead).getUTCMinutes();
                                const timeSeconds = new Date(timeRead).getUTCSeconds();
                                timeReadLabel = ("0" + timeMinutes).slice(-2) + ":" + ("0" + timeSeconds).slice(-2);
                            }

                            //Build a click Object to match the format in onCharClick
                            const clickObj = {
                                point: {
                                    activityId: id,
                                },
                            };
                            return (
                                <tr key={id} className="tracking-table-body-row" onClick={() => props.onChartClick(clickObj)}>
                                    <td className="tracking-table-body-cell activity-cell">
                                        {getActivityType(type, storyTags)}
                                        {!!hasComprehensionDialog && (
                                            <DialogIndicator tooltip="Activity has comprehension dialog." />
                                        )}
                                    </td>
                                    <td className="tracking-table-body-cell">{displayScore(score)}</td>
                                    <td className="tracking-table-body-cell">{storyTitle}</td>
                                    <td className="tracking-table-body-cell">{type === assignmentTypes.ASSESSMENT ? getGradeLabel(storyGrade) : '-'}</td>
                                    <td className="tracking-table-body-cell">{timeReadLabel}</td>
                                    <td className="tracking-table-body-cell">{new Date(date).toLocaleDateString()}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
